import { IAppState } from '../../../AppModulesWrapper';

import { IAreaPart } from '../../types/reducers/offer';

export const selectAreaParts = (state: IAppState): IAreaPart[] | null | undefined => {
  return state.servicePickerWidget.offer.areaParts;
};
